export const CHARGE_MODE = {//收费模式
  HOUR: "24小时",
  DAY: "白天/黑夜",
  CUSTOM: "自定义",
};
export const CAR_TYPE = {//车辆类型
  SMALL: "小车",
  BIG: "大车",
  ENERGY: "新能源",
};
export const PLATE_TYPE = {//车牌类型
  TEMP: "临时车",
  SAVE: "储值车",
  APPOINT: "预约车",
  DEBT: "违约车",
};
export const  QUOTA_TYPE={//限额类型
    LIMIT_TYPE_ONCE:"当次限额" ,
    LIMIT_TYPE_24:"24小时",
    LIMIT_TYPE_NATURAL:"自然天",
    LIMIT_TYPE_DAY:"白天黑夜"
}
export const CIRCULAR_BILLING_TYPE={//循环计费类型
    FIRST:"含首时段不含免费时段",
    FREE_FIRST_NOT:"不含免费时段与首时段",
    FREE_AND_FIRST:"不含免费时段与首时段"
}
export const CHARGE_TYPE={//延续类型
    NEXT:"按次",
    TIME:"按时"
}
export const CONTINUE_TYPE={
    NO:"无",
    CURRENT_LIMIT:"当前限额周期",
    NEXT_LIMIT:"后一个限额周期"
}